import { render, staticRenderFns } from "./g-alert-border.vue?vue&type=template&id=2b2c9e15&scoped=true&"
import script from "./g-alert-border.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-alert-border.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-alert-border.vue?vue&type=style&index=0&id=2b2c9e15&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c9e15",
  null
  
)

export default component.exports